<header class="header-panel">
    <nav class="navbar navbar-expand-lg fixed-top shadow-sm bg-white patent-plus-logo patent-plus-design">
        <div class="header-main-panel" id="navbarToggle">
            <div class="center-panel" *ngIf="logoPath != undefined">
                <a class="navbar-brand">
                    <img id="imgLogo" src={{logoPath}} />
                    <span class="version-text">{{this.appVersion}}</span>
                </a>
            </div>
        </div>
    </nav>
</header>
<div [hidden]="cancelValue=='true'">

<form class="form-horizontal" [formGroup]="customerForm">
    <div class="roi-document-section">
        <div class="card" [hidden]="isUserAuth">
            <div class="card-header">
                <div style="float:left">
                    <h3>User Authentication</h3>
                </div>
                <div style="float:right">
                </div>
            </div>
            <div class="authentication-panel">
                <div class="card-footer controlset">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-7 col-sm-12 center_div">
                                <div class="card box">
                                    <div class="row">
                                        <div class="col-lg-9 col-md-9 col-sm-12" [ngClass]="{'has-error': form.userPhone.errors && (form.userPhone.touched || form.userPhone.dirty)}">
                                            <label class="control-label" for="userPhone">Please enter the last 4 digits of your Mobile<span style="color:red">&nbsp;*</span></label>
                                            <div>
                                                <input type="text" id="userPhone" class="form-control" maxlength="4" formControlName="userPhone" (keyup.enter)="validateUserPhone()" />
                                                <div *ngIf="form.userPhone.errors && (form.userPhone.touched || form.userPhone.dirty)">
                                                    <div *ngIf="form.userPhone.errors.required">Moble phone is a required field</div>
                                                    <div *ngIf="form.userPhone.errors.pattern">Mobile phone must be number and upto 4 digits are allowed</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-3 col-sm-12">
                                            <div class="btn-group" style="margin-top:30px; display:block;">
                                                <button class="btn btn-success" type="button" title="Submit" (click)="validateUserPhone()" style="width:100%">Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row center_div">
                                        <label class="control-label alert-danger">{{authMsg}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" *ngIf="isUserAuth">
            <div class="card-header">
                <div>
                    <h3>{{panelTitle}}</h3>
                </div>
                <!--<div style="float:right">
                </div>-->
            </div>
            <div class="card-body">
                <div id="dvDocumentList" *ngIf="isExecuted">
                    <div class="document-module">
                        <div #dvDocumentlst>
                            <div class="card">
                                <div class="card-footer">
                                    <div class="document-list-spinner">
                                        <h6>Documents List</h6>
                                        <div class="document-list-text" *ngIf="loading">
                                            <span>Downloading...</span>
                                            <div class="spinner-doc"></div>
                                        </div>
                                        <div class="document-list-text" *ngIf="popLoading">
                                            <span>Processing...</span>
                                            <div class="spinner-doc"></div>
                                        </div>

                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="">
                                        <div class="center_div">
                                            <div class="doc">
                                                <div class="canvas_div_pdf" id="div1">
                                                    <div class="table-grid-panel">
                                                        <mat-table [dataSource]="dataSourceGenContract" matSort style="min-height:calc(100% - 200px); max-height:calc(95vh - 200px); overflow:auto;">

                                                            <ng-container matColumnDef="fileName">
                                                                <mat-header-cell *matHeaderCellDef mat-sort-header>File Name </mat-header-cell>
                                                                <mat-cell *matCellDef="let element"><span class="mobile-label">File Name</span> {{element.fileName}} </mat-cell>
                                                            </ng-container>
                                                            <ng-container matColumnDef="dtCreated">
                                                                <mat-header-cell *matHeaderCellDef mat-sort-header>Created Date Time </mat-header-cell>
                                                                <mat-cell *matCellDef="let element"><span class="mobile-label">Created Date Time</span> {{element.dtCreated | date: 'MMM-dd-yyyy  h:mm:ss'}} </mat-cell>
                                                            </ng-container>

                                                            <ng-container matColumnDef="unZipDoc">
                                                                <mat-header-cell *matHeaderCellDef style="margin-left: 0px; width: 100px;">View</mat-header-cell>
                                                                <mat-cell *matCellDef="let element">
                                                                    <span class="mobile-label">Documents</span>
                                                                    <button class="btn btn-success float-left" title="View contracts documents" [disabled]="loading" mat-button (click)="getCompressedFiles(element.fileName, 'contih','popup')"><mat-icon>visibility</mat-icon></button>
                                                                </mat-cell>
                                                            </ng-container>
                                                            <ng-container matColumnDef="zipDoc">
                                                                <mat-header-cell *matHeaderCellDef style="margin-left: 0px; width: 100px;">Download All</mat-header-cell>
                                                                <mat-cell *matCellDef="let element">
                                                                    <span class="mobile-label">Documents</span>
                                                                    <button class="btn btn-success float-left" title="Download contracts documents" [disabled]="loading" mat-button (click)="downloadFile(element.fileName, 'contih','')"><mat-icon>archive</mat-icon></button>
                                                                </mat-cell>
                                                            </ng-container>



                                                            <mat-header-row *matHeaderRowDef="displayedGenContractColumns; sticky: true"></mat-header-row>
                                                            <mat-row *matRowDef="let row; columns: displayedGenContractColumns;"></mat-row>
                                                        </mat-table>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" *ngIf="!isExecuted">
                <div class="card-header">
                    <div>
                        <h3>{{userMessage}}</h3>
                    </div>
                    <!--<div style="float:right">
                    </div>-->
                </div>
            </div>
            <div class="modal fade show contract-modalV1" id="modalExportCompressFile" tabindex="-1" role="dialog" aria-labelledby="modalExportCompressFile" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered model-lg download-document-modal" role="Document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-left" id="modalExportCompressFileTitle">Contract Files</h4>
                            <button (click)="hideFilesList()" data-dismiss="modal"><span>x</span></button>
                        </div>
                        <div class="modal-body">

                            <div class="document-list-spinner" *ngIf="pop2Loading">
                                <h6></h6>
                                <div class="document-list-text">
                                    <span>Downloading...</span>
                                    <div class="spinner-doc"></div>
                                </div>

                            </div>
                            <div class="document-module">
                                <div #dvDocumentlstazure>
                                    <div class="card">
                                        <div class="card-body">

                                            <div class="center_div">
                                                <div class="doc">
                                                    <div class="canvas_div_pdf" id="div12">
                                                        <div id="ulList" class="table-grid-panel">
                                                            <!--dataSourceGenContractPopUp-->
                                                            <mat-table #sortDocPopUp="matSort" [dataSource]="dataSourceSingleFile" matSort style="max-height: 217px; overflow: auto;">

                                                                <ng-container matColumnDef="fileName">
                                                                    <mat-header-cell *matHeaderCellDef mat-sort-header>File Name </mat-header-cell>
                                                                    <mat-cell *matCellDef="let element"><span class="mobile-label">File Name</span> {{element.fileName}} </mat-cell>
                                                                </ng-container>


                                                                <ng-container matColumnDef="unZipDoc">
                                                                    <mat-header-cell *matHeaderCellDef style="margin-left: 0px; width: 100px;"> Download </mat-header-cell>
                                                                    <mat-cell *matCellDef="let element">
                                                                        <span class="mobile-label">Documents</span>
                                                                        <button class="btn btn-success float-left" [disabled]="loading" title="Download contracts documents" mat-button (click)="downloadSingalFile(element.zipName, 'contih',element.fileName)"><mat-icon>archive</mat-icon></button>
                                                                    </mat-cell>
                                                                </ng-container>




                                                                <mat-header-row *matHeaderRowDef="displayedSingleFileColumns; sticky: true"></mat-header-row>
                                                                <mat-row *matRowDef="let row; columns: displayedSingleFileColumns;"></mat-row>
                                                            </mat-table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
</div>
